<template>
  <el-form ref="form" :model="form" :rules="rules" :label-width="label_width" label-position="left">
    <el-form-item label="类型">{{type.name}}</el-form-item>
    <el-row :gutter="20" v-if="teachers">
      <el-col :span="12">
        <el-form-item label="教师" prop="teacher_uid">
          <el-select class="full-width" placeholder="请选择教师" v-model="form.teacher_uid"
                     filterable :filter-method="filterTeacher" @visible-change="filterTeacher('')">
            <el-option v-for="teacher in filtered_teachers" :label="teacher.name"
                       :value="teacher.uid" :key="teacher.uid">
              <span v-html="$highlight(teacher.name, teacher.$$pinyin.name)"></span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="身份证号">
          {{teacher_map_id_number[achievement.teacher_uid]}}
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" v-for="(col, index) in getFormRows(type.form)" :key="index">
      <el-col v-for="item in col" :key="item.prop" :span="getFormItemSpan(item)">
        <el-form-item :label="item.name" :prop="item.prop">
          <el-input v-if="item.type === 'string'" :value="form[item.prop]"
                    @input="form[item.prop] = item.prop === 'student_name' ? handleStudentName($event): $event"
                    :placeholder="'请输入'+item.name"></el-input>
          <el-date-picker v-else-if="item.type === 'date'" class="full-width"
                          :placeholder="'请选择' + item.name"
                          :type="item.unit || 'date'" :value="form[item.prop]"
                          @input="form[item.prop] = formatDate($event, item.unit)"></el-date-picker>
          <el-select v-else-if="item.type === 'select'" v-model="form[item.prop]"
                     :multiple="item.multiple === true" class="full-width" :placeholder="'请选择' + item.name">
            <el-option v-for="option in item.select" :label="option"
                       :value="option" :key="option"></el-option>
          </el-select>
          <template v-else-if="item.type === 'file'">
            <select-file :accept="item.accept" :multiple="!item.limit || item.limit > 1"
                         :value="form[item.prop]"
                         @change="form[item.prop] = getFiles($event, item.limit)"
                         :disabled="form[item.prop].length >= item.limit">
              <el-button size="small" type="primary" :disabled="form[item.prop].length >= item.limit">
                {{item.limit === 1 ? '选择' : '添加'}}文件
              </el-button>
            </select-file>
            <span class="el-upload__tip">
              <span v-if="item.limit > 1">最多添加 {{item.limit}} 个附件;</span>
              <span>鼠标移动到文件上点击<i class="el-icon-close text-danger f-s-0_9"></i>可删除</span>
            </span>
            <ul class="el-upload-list">
              <li v-for="(file, index) in form[item.prop]"
                  class="el-upload-list__item" :key="index">
                <a class="el-upload-list__item-name" :href="file.url" download target="_blank">
                  <icon :name="file.name | fileicon"></icon>
                  {{file.name || '(未命名)'}}
                </a>
                <i class="el-icon-close text-danger" @click="form[item.prop].splice(index, 1)"></i>
              </li>
            </ul>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import merge from 'lodash/merge'
import isArray from 'lodash/isArray'
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import dateUtil from 'element-ui/src/utils/date'

import { equals } from 'utils/lang'

import formRowMixin from './formRowMixin'

export default {
  model: {prop: 'achievement', event: 'update'},
  props: {
    achievement: {
      type: Object,
    },
    type: {
      type: Object,
      required: true,
    },
    teachers: {
      type: Array,
    },
    label_width: {
      type: String,
    },
  },
  mixins: [formRowMixin],
  data () {
    return {
      form: null,
      rules: null,
      search: '',
      teacher_map_id_number: null,
      formats: {date: 'yyyy-MM-dd', month: 'yyyy-MM'},
    }
  },
  computed: {
    filtered_teachers () {
      return this.$search(this.teachers, this.search, ['name', 'id_number'])
    },
  },
  methods: {
    init () {
      if (!this.achievement) return
      let form = merge(this.form || {}, this.achievement)
      form.name = this.type.name
      let rules = {}
      if (this.teachers) {
        rules.teacher_uid = [this.$rules.required('教师为必填项')]
        form.teacher_uid = form.teacher_uid || ''
      }
      this.type.form.forEach(item => {
        if (item.required) rules[item.prop] = [this.$rules.required(item.name + '为必填项')]
        if (item.prop === 'student_name') {
          rules[item.prop] = rules[item.prop] || []
          let max = 6
          rules[item.prop].push({max, message: `${item.name}长度最多为 ${max}`, trigger: 'blur,change'})
        }
        let v = form[item.prop]
        if (item.type === 'string') {
          v = typeof v === 'string' ? v : ''
          if (item.prop === 'student_name') v = this.handleStudentName(v, true)
        } else if (item.type === 'select') {
          if (item.multiple) {
            if (isArray(v)) {
              v = v.filter(i => typeof i === 'string').map(i => i.trim()).filter(i => item.select.includes(i))
            } else {
              v = []
            }
          } else {
            v = typeof v === 'string' && item.select.includes(v.trim()) ? v.trim() : ''
          }
        } else if (item.type === 'date') {
          v = this.parseDate(v, item.unit)
        } else if (item.type === 'file') {
          v = isArray(v) ? v.filter(o => o && !equals(o, {})) : []
        }
        form[item.prop] = v
      })
      this.form = form
      this.rules = rules
    },
    initTeacher () {
      this.teacher_map_id_number = mapValues(keyBy(this.teachers, 'uid'), 'id_number')
    },
    getFiles (files, limit) {
      if (!files) return []
      if (!limit || files.length < limit) return files
      return files.slice(files.length - limit)
    },
    formatDate (date, unit = 'date') {
      if (!date) return ''
      return dateUtil.format(date, this.formats[unit] || this.formats.date)
    },
    parseDate (dateStr, unit) {
      if (!dateStr) return ''
      for (let format of ['yyyy-MM', 'yyyy-MM-dd', 'yyyy/MM', 'M/D/yy', 'MM/dd/yyyy']) {
        let date = dateUtil.parse(dateStr, format)
        if (date) return this.formatDate(date, unit)
      }
      return ''
    },
    validate (callback) {
      this.$refs.form.validate(callback)
    },
    validateField (prop, callback) {
      this.$refs.form.validateField(prop, callback)
    },
    filterTeacher (search) {
      this.search = search
    },
    handleStudentName (value, trim = false) {
      if (!value) return ''
      if (!value.trim()) return value
      if (!/[a-z]/ig.test(value)) {
        return value.replace(/\s+/g, '')
      } else if (trim) {
        return value.replace(/\s+/g, ' ')
      }
      return value
    },
  },
  created () {
    this.initTeacher()
    this.init()
  },
  watch: {
    achievement: {
      deep: true,
      handler () {
        if (this.form !== this.achievement && !equals(this.form, this.achievement)) {
          this.init()
        }
      },
    },
    form: {
      deep: true,
      handler () {
        if (this.form !== this.achievement && !equals(this.form, this.achievement)) {
          this.$emit('update', this.form)
        }
      },
    },
    teachers: 'initTeacher',
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.el-upload-list {
  max-width: 300px;
  .el-upload-list__item {
    margin: 0;
    padding: 2px 0;
    .el-icon-close {
      color: $color-danger;
      font-size: 1.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementForm.vue